import { Injectable } from '@angular/core';
import forOwn from 'lodash/forOwn';
import get from 'lodash/get';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

@Injectable()
export class HostNameInterpolationCompiler extends TranslateMessageFormatCompiler {
  constructor() {
    super();
  }

  public compileTranslations(translations: any, lang: string) {
    const references = { references: translations.references };
    const replaced = this._replaceHostNameInTranslations(translations, references);
    return super.compileTranslations(replaced, lang);
  }

  private _replaceHostNameInTranslations(data: any, references: any) {
    if (typeof data === 'object' && data !== null) {
      const result = {};
      forOwn(data, (value, key) => {
        if (typeof value === 'object' && value !== null) {
          result[key] = this._replaceHostNameInTranslations(value, references);
        } else {
          result[key] = this._replaceHostName(value, references);
        }
      });
      return result;
    } else {
      return this._replaceHostName(data, references);
    }
  }

  private _replaceHostName(value, references) {
    if (value.indexOf('references.') >= 0) {
      try {
        const referencePlaceholder = /{(references.*?)}/g.exec(value)[1];
        const referenceText = get(references, referencePlaceholder);

        if (referenceText) {
          return value.replace('{' + referencePlaceholder + '}', referenceText);
        } else {
          return '';
        }
      } catch (e) {
        return '';
      }
    }
    return value;
  }
}
